var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"run-board"},[_c('map-bg',{ref:"map"}),_c('search',{ref:"search"}),_c('category-tab',{ref:"category",on:{"getInitView":_vm.getInitView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }